import { MenuBar } from './MenuBar'
import { withMenuBar } from './withMenuBar'

const ConnectedMenuBar = withMenuBar(MenuBar)
export { ConnectedMenuBar as MenuBar }
